// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  width: 100%;
  height: 80px;
  overflow: hidden;
  margin-left: 190px;
}

.setting-icon-container:hover {
  border-radius: 50%;
}
.icon-pro-close {
  font-size: 12px !important;
  line-height: 30px !important;
  display: inline-block;
  /* margin: 0px 5px; */
  opacity: 0.3;
}
.header-sort-icon {
  float: left;
  margin-top: 3px;
  font-size: 26px;
}
.header-archive-icon {
  float: left;
  margin-top: 3px;
  font-size: 21px;
}
.header-feedback {
  font-size: 15px;
  color: rgb(35, 170, 242);
}
.only-local-container {
  position: absolute;
  left: 520px;
  margin-top: 29px;
}
.only-local-text {
  float: left;
  font-size: 15px;
  line-height: 27px;
  opacity: 1;
}
.only-local-icon {
  float: left;
  margin-top: 6px;
  margin-left: 6px;
  width: 30px;
  height: 16px;
  border-radius: 10px;
  cursor: pointer;
}
.only-local-slider {
  float: left;
  margin-top: 2px;
  margin-left: 2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.import-from-cloud {
  margin-right: 20px;
  margin-top: 23px;
  width: 138px;
  max-width: 158px;
  height: 42px;
  opacity: 1;
  padding: 0 !important;
  border-radius: 25px;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
  transition: 0.2s;
  position: fixed;
  right: 0px;
  top: 0px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}
.import-from-cloud:hover .animation-mask {
  transform: scaleX(1);
}
.import-from-local:hover .animation-mask-local {
  transform: scaleX(1);
}
@media screen and (max-width: 950px) {
  .import-from-cloud {
    position: fixed;
    left: 15px;
    top: calc(100vh - 110px);
    width: 138px;
  }
  .import-from-local {
    position: fixed !important;
    left: 15px;
    top: calc(100vh - 80px) !important;
    width: 138px;
    padding: 0px !important;
  }
  .header-report-container {
    right: 15px !important;
  }
}
.download-demo-book {
  text-decoration: underline;
  width: 200px;
  position: absolute;
  left: 690px;
  top: 29px;
  cursor: pointer;
  color: #0078d4;
}
@media screen and (max-width: 1250px) {
  .download-demo-book {
    display: none;
  }
}
.animation-mask,
.animation-mask-local {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  transition: 0.1s;
  transform: scaleX(0);
  transform-origin: left;
  border-radius: 19px;
}
.setting-icon-parrent {
  position: absolute;
  top: 18px;
  margin-left: 280px;
  height: 50px;
  z-index: 1;
}
.header-search-container {
  position: absolute;
  top: 23px;
  margin-left: 40px;
  width: 220px;
}
.setting-icon {
  float: left;
  font-size: 25px;
}
.header-report-container {
  text-align: right;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  border-radius: 5px;
  padding-left: 10px;
  padding-right: 10px;
  position: absolute;
  top: 30px;
  right: 180px;

  text-underline-offset: 3px;
}
.setting-icon-container {
  width: 50px;
  height: 50px;
  font-size: 25px;
  line-height: 50px;
  cursor: pointer;
  transition: 0.1s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 15px;
  float: left;
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.icon-rotate {
  animation: rotate 2s linear infinite;
}
.header-chat-widget {
  position: absolute;
  right: 20px;
  bottom: 40px;
  z-index: 1000;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  transform: scale(1);
}

.header-chat-widget:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  transform: scale(1.05) translateY(-3px);
}
`, "",{"version":3,"sources":["webpack://./src/containers/header/header.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,eAAe;IACf,UAAU;IACV,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,0BAA0B;IAC1B,UAAU;IACV,kCAAkC;IAClC,YAAY;IACZ,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;;EAEZ,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;AACzC","sourcesContent":[".header {\n  width: 100%;\n  height: 80px;\n  overflow: hidden;\n  margin-left: 190px;\n}\n\n.setting-icon-container:hover {\n  border-radius: 50%;\n}\n.icon-pro-close {\n  font-size: 12px !important;\n  line-height: 30px !important;\n  display: inline-block;\n  /* margin: 0px 5px; */\n  opacity: 0.3;\n}\n.header-sort-icon {\n  float: left;\n  margin-top: 3px;\n  font-size: 26px;\n}\n.header-archive-icon {\n  float: left;\n  margin-top: 3px;\n  font-size: 21px;\n}\n.header-feedback {\n  font-size: 15px;\n  color: rgb(35, 170, 242);\n}\n.only-local-container {\n  position: absolute;\n  left: 520px;\n  margin-top: 29px;\n}\n.only-local-text {\n  float: left;\n  font-size: 15px;\n  line-height: 27px;\n  opacity: 1;\n}\n.only-local-icon {\n  float: left;\n  margin-top: 6px;\n  margin-left: 6px;\n  width: 30px;\n  height: 16px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n.only-local-slider {\n  float: left;\n  margin-top: 2px;\n  margin-left: 2px;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n}\n.import-from-cloud {\n  margin-right: 20px;\n  margin-top: 23px;\n  width: 138px;\n  max-width: 158px;\n  height: 42px;\n  opacity: 1;\n  padding: 0 !important;\n  border-radius: 25px;\n  font-size: 15px;\n  line-height: 18px;\n  text-align: center;\n  box-sizing: border-box;\n  cursor: pointer;\n  transition: 0.2s;\n  position: fixed;\n  right: 0px;\n  top: 0px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.import-from-cloud:hover .animation-mask {\n  transform: scaleX(1);\n}\n.import-from-local:hover .animation-mask-local {\n  transform: scaleX(1);\n}\n@media screen and (max-width: 950px) {\n  .import-from-cloud {\n    position: fixed;\n    left: 15px;\n    top: calc(100vh - 110px);\n    width: 138px;\n  }\n  .import-from-local {\n    position: fixed !important;\n    left: 15px;\n    top: calc(100vh - 80px) !important;\n    width: 138px;\n    padding: 0px !important;\n  }\n  .header-report-container {\n    right: 15px !important;\n  }\n}\n.download-demo-book {\n  text-decoration: underline;\n  width: 200px;\n  position: absolute;\n  left: 690px;\n  top: 29px;\n  cursor: pointer;\n  color: #0078d4;\n}\n@media screen and (max-width: 1250px) {\n  .download-demo-book {\n    display: none;\n  }\n}\n.animation-mask,\n.animation-mask-local {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  transition: 0.1s;\n  transform: scaleX(0);\n  transform-origin: left;\n  border-radius: 19px;\n}\n.setting-icon-parrent {\n  position: absolute;\n  top: 18px;\n  margin-left: 280px;\n  height: 50px;\n  z-index: 1;\n}\n.header-search-container {\n  position: absolute;\n  top: 23px;\n  margin-left: 40px;\n  width: 220px;\n}\n.setting-icon {\n  float: left;\n  font-size: 25px;\n}\n.header-report-container {\n  text-align: right;\n  height: 30px;\n  line-height: 30px;\n  cursor: pointer;\n  border-radius: 5px;\n  padding-left: 10px;\n  padding-right: 10px;\n  position: absolute;\n  top: 30px;\n  right: 180px;\n\n  text-underline-offset: 3px;\n}\n.setting-icon-container {\n  width: 50px;\n  height: 50px;\n  font-size: 25px;\n  line-height: 50px;\n  cursor: pointer;\n  transition: 0.1s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 15px;\n  float: left;\n}\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.icon-rotate {\n  animation: rotate 2s linear infinite;\n}\n.header-chat-widget {\n  position: absolute;\n  right: 20px;\n  bottom: 40px;\n  z-index: 1000;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  overflow: hidden;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  transform: scale(1);\n}\n\n.header-chat-widget:hover {\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  transform: scale(1.05) translateY(-3px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
